export const MAIL = {
    TYPE: {
        DAILY_REPORT: 1,
        BANKED_TIME: 2,
        LEAVE_TIME: 3,
        ON_SITE_MEMBER: 4,
        VISITOR: 5,
        UNRECOGNIZED_ACTIVITY: 6
    },
    LINK: {
        EMAIL: 1,
        USER: 2,
    }
}